import { jsx as l } from "react/jsx-runtime";
import { W as t } from "../../vendor--aJiswR_.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as o } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index47.css';const r = "_label_1729m_1", a = {
  label: r
};
function s(e) {
  return e.children ? /* @__PURE__ */ l(
    t,
    {
      ...o(e),
      elementType: "label",
      className: a.label,
      "data-component": "FieldLabel",
      slot: "label"
    }
  ) : null;
}
export {
  s as FieldLabel
};
//# sourceMappingURL=index.js.map
